import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LabelLift from "../UI/LabelLift";
import LiftLine from "./components/LiftLine";

const Lift3 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift3"
			 className={getLiftClass(isOpen, activeLiftId === '3', state)}
			 transform="translate(685.498047, 680.000000)"
		>
			<LiftLine x1="357" y1="13" x2="29.5273379" y2="166.78167" id="Line" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="6"
				colors={getLiftStatusColors(state, isOpen)}
				coords="77, 118"
				isOpen={isOpen}
				animationPart={3}
			/>

			<g>
				<g id="Labe-lift" transform="translate(0.000000, 160.000000)">
					<rect stroke={colors[2]} strokeWidth="3" fill="#FFFFFF" fillRule="evenodd" x="0" y="0" width="26" height="26" rx="11"/>
				</g>

				<polygon
					fill={colors[2]}
					transform="translate(14.000000, 172.500000) scale(-1, 1) rotate(-337.000000) translate(-14.000000, -172.500000)"
					points="9 172.5 19 167 16.8441025 172.5 19 178"/>
			</g>

			<LabelLift coords="344.000000, 0.000000" text={<tspan x="1" y="13">3</tspan>} isOpen={isOpen} state={state}/>

		</g>
	);
};

Lift3.propTypes = {};

export default Lift3;
